import React, { useState, useEffect } from 'react'
import { IconButton, Box } from '@mui/material'
import {
  ProgressionFilters,
  D3VerticalStacked,
  MuiButton,
  MuiButtons,
  CustomTooltip
} from '../../../../components'
import { LEGEND_COLOR_MAP_NEW } from '../../../../constants'
import { sortingDataForProgressionTabList, getDistinctValues } from '../../../../util'
import { ClosePopup, IconArrowDown, IconExpand } from '../../../../assets/images/icons'
import { IconClose } from '../../../../assets/images/iconsV2'
import { useGlobalStore } from '../../../../store'
import ProgressionRange from './progressionRange'

import {
  SegmentRow,
  SegmentWrap,
  SegmentRowHeading,
  SegmentRowDetails,
  SegmentDetailsLevel2,
  SegmentDetailsLevel3,
  SegmentAccordionLevelHeading,
  ProgressionWrapper,
  Button,
} from './style'

const ComparisonTable = ({
  isPPTModalActive,
  progressionRangeArray,
  parentTypeIdL1,
  keyOrdering,
  data,
  segmentData = {},
  type,
  filterType,
  expanded,
  filterUpdated,
  progressionRangeObject,
  updateProgressionRange,
  insightsElementType,
  insightsElementId,
}) => {
  const [segmentDataLevel1, setSegmentDataLevel1] = useState()
  const [segmentDataL1Filtered, setSegmentDataL1Filtered] = useState({
    drivers: [],
    segments: [],
    periods: [],
  })
  const [segmentDataLevel3, setSegmentDataLevel3] = useState()
  const [segmentDataLevel1MaxValue, setSegmentDataLevel1MaxValue] = useState(100)
  const [progressionData, setProgressionData] = useState(null)
  const [expandedLevel1Data, setExpandedLevel1Data] = useState(null)
  const [expandedLevel2Data, setExpandedLevel2Data] = useState(null)
  const [onLoadProgressionData, setOnLoadProgressionData] = useState(null)
  const [driversArray, setDriversArray] = useState([])

  const getData = (
    dd,
    field = 'SegmentDrivers',
    field2 = 'SegmentDrivers',
    level = 0,
    isInner = true
  ) => {
    const obj = {}
    const percentArr = []
    for (let index = 0; index < dd?.length; index++) {
      const element = dd[index]
      const keyName = element.parentDriveName

      const driverElement = element?.[field]?.[field2]
      const drivers = Array.isArray(driverElement)
        ? driverElement
        : Object.keys(driverElement || {})?.length
          ? [driverElement]
          : []

      for (let j = 0; j < drivers.length; j++) {
        const innerElement = drivers[j]
        const key = level === 1 ? innerElement.AttributeName : innerElement.SubAttributeName

        const associationData = [
          {
            SearchKeywords: innerElement.Percent,
          },
        ]

        const multiBarData = [
          {
            Positive: innerElement.PositivePercent,
            Neutral: innerElement.NeutralPercent,
            Mixed: innerElement.MixedPercent,
            Negative: innerElement.NegativePercent,
          },
        ]

        obj[key] = {
          ...(obj[key] || {}),
          [keyName]: {
            ...innerElement,
            data: type ? associationData : multiBarData,
            // data: multiBarDataCount === 0 ? associationData : multiBarData
          },
        }
        percentArr.push(innerElement.Percent)
      }
    }

    const maxPercent = Math.max(...percentArr)
    return { object: obj, maxVal: maxPercent }
  }
  const expandLevel1Func = (key) => {
    let dataLevel1 = { ...segmentDataLevel1 }
    const objKeys = Object.keys(segmentDataLevel1)
    let objIndex = 0
    for (let i = 0; i < objKeys.length; i++) {
      // resetting values except the KEY one
      if (objKeys[i] === key) objIndex = i
      else {
        dataLevel1[objKeys[i]].expandedLevel1 = false
        dataLevel1[objKeys[i]].expandedLevel1Key = null
        dataLevel1[objKeys[i]].expandedLevel1Index = null
      }
      dataLevel1[objKeys[i]].expandedLevel2 = false
      dataLevel1[objKeys[i]].expandedLevel2Key = null
      dataLevel1[objKeys[i]].expandedLevel2Index = null
    }
    const show = !dataLevel1[key]?.expandedLevel1
    dataLevel1[key].expandedLevel1 = show
    dataLevel1[key].expandedLevel1Key = show ? key : null
    dataLevel1[key].expandedLevel1Index = show ? objIndex : null

    setSegmentDataLevel1(dataLevel1)
    setExpandedLevel1Data({
      key: key,
      index: objIndex,
      itemLevel1: dataLevel1[key],
      segmentDataLevel1: dataLevel1,
    })
  }
  const expandLevel2Func = (key, index, key2, showButton = false) => {
    const dataLev2 = { ...segmentDataLevel1 }
    const getDataLevel3FuncData = getDataLevel3Func(dataLev2[key].dataLevel2[key2], key2)
    let dataLev3 = getDataLevel3FuncData.object

    if (Object.keys(dataLev3).length === 0) {
      dataLev3 = null
    }
    if (showButton) {
      return isNaN(dataLev3)
    } else {
      let objIndex = 0
      if (
        key === dataLev2[key].expandedLevel1Key &&
        key2 === dataLev2[key].expandedLevel2Key &&
        index === dataLev2[key].expandedLevel2Index
      ) {
        dataLev2[key].expandedLevel2 = false
        dataLev2[key].expandedLevel2Index = null
        dataLev2[key].expandedLevel2Key = null

        setSegmentDataLevel1(dataLev2)
        setExpandedLevel2Data({
          key: key,
          index: objIndex,
          itemLevel1: dataLev2[key],
          segmentDataLevel1: dataLev2,
        })
        setSegmentDataLevel3(dataLev3)
      } else {
        const dataLev2ObjectKeys = Object.keys(dataLev2[key].dataLevel2)
        for (let i = 0; i < dataLev2ObjectKeys.length; i++) {
          if (dataLev2ObjectKeys[i] === key2) {
            objIndex = i
            dataLev2[key].expandedLevel2 = true
            dataLev2[key].expandedLevel2Index = objIndex
            dataLev2[key].expandedLevel2Key = key2
          } else {
            dataLev2[key].dataLevel2[dataLev2ObjectKeys[i]].expandedLevel2 = false
            dataLev2[key].dataLevel2[dataLev2ObjectKeys[i]].expandedLevel2Index = null
            dataLev2[key].dataLevel2[dataLev2ObjectKeys[i]].expandedLevel2Key = null
          }
        }

        setSegmentDataLevel1(dataLev2)
        setExpandedLevel2Data({
          key: key,
          index: objIndex,
          itemLevel1: dataLev2[key],
          segmentDataLevel1: dataLev2,
        })
        setSegmentDataLevel3(dataLev3)
      }
    }
  }
  const getDataLevel1Func = (key) => {
    const objKeys = Object.keys(segmentData[key])
    const level2Array = []
    const maxPercentArray = []
    for (let i = 0; i < objKeys.length; i++) {
      const finalObject = { ...segmentData[key][objKeys[i]], parentDriveName: objKeys[i] }
      maxPercentArray.push(finalObject.Percent)
      level2Array.push(finalObject)
    }
    const maxPercentValue = Math.max(...maxPercentArray)
    return {
      ...getData(level2Array, 'DriverAttributes', 'DriverAttributeElement', 1),
      eachCardMaxValue: maxPercentValue,
    }
  }
  const getDataLevel3Func = (segmentData, key) => {
    const objKeys = Object.keys(segmentData)
    const level3Array = []
    for (let i = 0; i < objKeys.length; i++) {
      const finalObject = { ...segmentData[objKeys[i]], parentDriveName: objKeys[i] }
      level3Array.push(finalObject)
    }
    return getData(level3Array, 'DriverSubAttributes', 'DriverSubAttributeElement', 2)
  }

  const getDriversFunc = () => {
    return Object.keys(segmentData) // THIS LINE WILL KEEP THE ORDER AS VOLUME, WHICH IS CORRENT..
    // return sortingDataForProgressionTabList(Object.keys(segmentData)) // NOTE: WE CANNOT ADD ORDERING AS ITS ORDERED BY VOLUME
  }
  const getSegmentsFunc = () => {
    const drivers = Object.keys(segmentData)
    const finalData = drivers
      .map((d) => Object.keys(segmentData[d]))
      .flat(1)
      .filter((value, index, array) => array.indexOf(value) === index)
    return sortingDataForProgressionTabList(finalData)
  }

  useEffect(() => {
    const objectKeys = Object.keys(segmentData)
    const segData = {}
    const maxValueLevel1Array = []
    for (let i = 0; i < objectKeys.length; i++) {
      const getDataLevel1FuncData = getDataLevel1Func(objectKeys[i]) // {object:obj, maxVal:maxPercent}
      maxValueLevel1Array.push(getDataLevel1FuncData.eachCardMaxValue)
      segData[objectKeys[i]] = {
        dataLevel1: segmentData[objectKeys[i]],
        expandedLevel1: false,
        expandedLevel1Key: '',
        expandedLevel1Index: null,
        expandedLevel1EachCardMaxValue: getDataLevel1FuncData.eachCardMaxValue,
        expandedLevel1MaxValue: null, // getDataLevel1FuncData.maxVal,

        dataLevel2: getDataLevel1FuncData.object,
        expandedLevel2: false,
        expandedLevel2Index: null,
        expandedLevel2MaxValue: getDataLevel1FuncData.maxVal,
        expandedLevel2Key: '',
      }
    }
    const maxValueLevel1value = Math.max(...maxValueLevel1Array)
    for (let i = 0; i < objectKeys.length; i++) {
      segData[objectKeys[i]].expandedLevel1MaxValue = maxValueLevel1value
    }
    setSegmentDataLevel1(segData)
  }, [segmentData])

  useEffect(() => {
    if (segmentDataLevel1) {
      const dataLev2 = { ...segmentDataLevel1 }
      const dataLev2ObjectKeys = Object.keys(dataLev2)
      for (let i = 0; i < dataLev2ObjectKeys.length; i++) {
        dataLev2[dataLev2ObjectKeys[i]].expandedLevel1 = expanded
        dataLev2[dataLev2ObjectKeys[i]].expandedLevel2 = false
      }
      setSegmentDataLevel1(dataLev2)
      filterUpdated()
    }
  }, [expanded])

  useEffect(() => {
    filterUpdated()
  }, [segmentDataLevel1])

  const onload = () => {
    const obj = { drivers: getDriversFunc(), [filterType]: getSegmentsFunc() }
    setProgressionData(obj)
    setSegmentDataL1Filtered(obj)
  }

  useEffect(() => {
    onload()
    window.addEventListener('resize', onload)
    return () => window.removeEventListener('resize', onload)
  }, [])

  useEffect(() => {
    if (progressionData?.periods?.length > 0 && filterType === 'periods') {
      const data = { ...progressionData, periods: progressionData.periods.slice(0, 12) }
      setOnLoadProgressionData(data)
    }
  }, [progressionData])

  const getCardWidth = (selector, progressRangeObject, padding = 0) => {
    const parentWidth =
      document.getElementById(parentTypeIdL1)?.querySelector(selector)?.getBoundingClientRect()
        ?.width -
      padding * 2
    if (parentWidth) {
      const cardGap = 12
      const cardCols = Math.floor((parentWidth + cardGap) / progressRangeObject.minWidth)
      const cardGapAdjustment = cardGap / cardCols
      const cardWidth = Math.floor(parentWidth / cardCols - cardGap + cardGapAdjustment)
      return { width: cardWidth, cols: cardCols }
    }
    return { width: progressRangeObject.minWidth, cols: 200 }
  }

  const dummyObj = (key) => {
    const object = {
      InsightsElementId: '00000000-0000-0000-0000-000000000000',
      DriverId: '00000000-0000-0000-0000-00000000000000',
      PositivePercent: 0,
      NeutralPercent: 0,
      MixedPercent: 0,
      NegativePercent: 0,
      Sentiment: 'Mixed',
      Percent: 0,
      DriverName: 'none',
    }
    return object
  }

  const setLevel1MaxValueFunc = () => {
    const keys = segmentDataL1Filtered.drivers
    const maxPercentArr = []
    for (let i = 0; i < keys.length; i++) {
      const keyData = segmentData[keys[i]]
      if(keyData){
        const childKeys = Object.keys(keyData)
        const len =
          childKeys.length > progressionRangeObject.barsInGraph
            ? progressionRangeObject.barsInGraph
            : childKeys.length
        for (let j = 0; j < len; j++) {
          maxPercentArr.push(keyData[childKeys[j]].Percent)
        }
      }
    }
    const maxPercentValue = Math.ceil(Math.max(...maxPercentArr) / 10) * 10
    setSegmentDataLevel1MaxValue(maxPercentValue)
  }

  const segmentDataL1FilteredFunc = (data) => {
    const arr = []
    for (let i = 0; i < data.length; i++) {
      const key = data[i]
      const item = segmentData[key]
      const itemLevel1 = segmentDataLevel1[key]
      const selectedItemsL1 = {}
      const arr1 = segmentDataL1Filtered[filterType]
      const len = Math.min(arr1.length, progressionRangeObject.barsInGraph)
        ? arr1.slice(0, progressionRangeObject.barsInGraph).length
        : arr1.length
      let isPercentValue = 0
      for (let s = 0; s < arr1.length; s++) {
        if (item?.[arr1?.[s]]) {
          selectedItemsL1[arr1[s]] = item[arr1[s]]
          if (item[arr1[s]].Percent > isPercentValue) {
            isPercentValue = item[arr1[s]].Percent
          }
        } else {
          selectedItemsL1[arr1[s]] = dummyObj(arr1[s])
        }
      }

      const card = getCardWidth('.segmentWrap', progressionRangeObject)
      if (isPercentValue > 0 && Object.keys(selectedItemsL1).length > 0) {
        arr.push({ selectedItemsL1: selectedItemsL1, itemLevel1: itemLevel1, card: card, key: key })
      }
    }
    return arr
  }

  const getModulusArray = (colLen) => {
    const len = driversArray.length
    const arr = []
    for (let i = 0; i < len; i++) {
      if (i % colLen === 0 && i + colLen < len) {
        arr.push(i + colLen - 1)
      } else if (i === len - 1) {
        arr.push(i)
      }
    }
    return arr
  }

  useEffect(() => {
    setLevel1MaxValueFunc()
    const array = segmentDataL1FilteredFunc(segmentDataL1Filtered.drivers)
    setDriversArray(array)
  }, [progressionRangeObject, segmentDataL1Filtered, updateProgressionRange])

  return (
    <>
      {segmentDataLevel1MaxValue &&
        segmentData &&
        segmentDataLevel1 &&
        segmentDataL1Filtered[filterType] &&
        segmentDataL1Filtered?.drivers && (
          <>
            {isPPTModalActive ? (
              <SegmentWrap className={'segmentWrap isPPTModalActive'}>
                {new Array(
                  Math.ceil(segmentDataL1FilteredFunc(segmentDataL1Filtered.drivers).length / 10)
                )
                  .fill(0)
                  .map((d, index) => {
                    const startIndex = index * 10
                    const endIndex = startIndex + 10
                    const segmentDataL1FilteredArray = segmentDataL1FilteredFunc(
                      segmentDataL1Filtered.drivers
                    ).slice(startIndex, endIndex)

                    return (
                      <div key={`driverWrap_${index}`} className={'segmentRows'}>
                        {segmentDataL1FilteredArray.map((data, i) => {
                          return (
                            <CardSection
                              key={'ppt_level1_' + data.key}
                              type='level_1'
                              title={data.key}
                              expandLevelFunc={expandLevel1Func}
                              keyOrdering={keyOrdering}
                              progressRangeObject={progressionRangeObject}
                              itemLevels={data.itemLevel1}
                              index={i}
                              selectedItemsL={data.selectedItemsL1}
                              cardWidth={data.card.width}
                              maxValue={segmentDataLevel1MaxValue}
                              insightsElementType={insightsElementType}
                              insightsElementId={insightsElementId}
                              isPPTModalActive={isPPTModalActive}
                            />
                          )
                        })}
                      </div>
                    )
                  })}
              </SegmentWrap>
            ) : (
              <SegmentWrap className={'segmentWrap'}>
                {updateProgressionRange &&
                  driversArray.map((data, i) => {
                    const showDetailSectionL1___ = () => {
                      if (expandedLevel1Data?.index >= 0) {
         
                        const modulusE = getModulusArray(data.card.cols).includes(i)
                        const driverLen = segmentDataL1Filtered.drivers.length - 1
                        const last = driverLen === i
                        const lastIndexDif = driverLen - (driverLen % data.card.cols)
                        const flag = modulusE && expandedLevel1Data?.index > (i - data.card.cols + 1) && expandedLevel1Data?.index <= i;

                        if (flag) {
                          return true
                        } else if (last && expandedLevel1Data?.index >= lastIndexDif) {
                          return true
                        }
                      }
                      return false
                    }

                    const showDetailSectionL1 = () => { // this is GPT function
                      if (expandedLevel1Data?.index === undefined || expandedLevel1Data.index < 0) {
                          return false;
                      }

                      const expandedIndex = expandedLevel1Data.index;
                      const cols = data.card.cols;
                      const totalCards = segmentDataL1Filtered.drivers.length;

                      const expandedRowEndIndex = Math.ceil((expandedIndex + 1) / cols) * cols - 1;
                      if (i === expandedRowEndIndex) {
                          return true;
                      }
                      if (expandedRowEndIndex >= totalCards) {
                          const lastCardIndex = totalCards - 1;
                          const firstIndexInLastRow = Math.floor(lastCardIndex / cols) * cols;
                          if (expandedIndex >= firstIndexInLastRow && i === lastCardIndex) {
                              return true;
                          }
                      }
                      
                      return false;
                    }


                    return (
                      <>
                        <CardSection
                          key={'level1 ' + data.key}
                          type='level_1'
                          title={data.key}
                          expandLevelFunc={expandLevel1Func}
                          keyOrdering={keyOrdering}
                          progressRangeObject={progressionRangeObject}
                          itemLevels={data.itemLevel1}
                          index={i}
                          selectedItemsL={data.selectedItemsL1}
                          cardWidth={data.card.width}
                          maxValue={segmentDataLevel1MaxValue}
                          insightsElementType={insightsElementType}
                          insightsElementId={insightsElementId}
                        />
                        {showDetailSectionL1() && (
                          <SegmentLevel2DetailSection
                            key={'level2_detail_section_' + expandedLevel1Data.key}
                            getCardWidth={getCardWidth}
                            itemLevel1={expandedLevel1Data.itemLevel1}
                            keyL2={expandedLevel1Data.key}
                            segmentDataL1Filtered={segmentDataL1Filtered}
                            filterType={filterType}
                            keyOrdering={keyOrdering}
                            segmentDataLevel3={segmentDataLevel3}
                            expandLevel2Func={expandLevel2Func}
                            progressRangeObject={progressionRangeObject}
                            progressionRangeObject={progressionRangeObject}
                            progressionRangeArray={progressionRangeArray}
                            onCloseL1={() => expandLevel1Func(expandedLevel1Data.key)}
                            expandedLevel2Data={expandedLevel2Data}
                            insightsElementType={insightsElementType}
                            insightsElementId={insightsElementId}
                          />
                        )}
                      </>
                    )
                  })}
              </SegmentWrap>
            )}
          </>
        )}
    </>
  )
}

export default ComparisonTable

const CardSection = ({
  type,
  title,
  expandLevelFunc,
  keyOrdering,
  progressRangeObject,
  itemLevels,
  index = 0,
  hadNextLevel,
  showLevel2Button,
  selectedItemsL,
  cardWidth,
  maxValue,
  insightsElementType,
  insightsElementId,
  isPPTModalActive,
}) => {
  const [showArrowButton, setShowArrowButton] = useState(false)
  const { driverProgressionPopupObject, setDriverProgressionPopupObject } = useGlobalStore()
  const trimName = (name) => {
    return name
      .replace(' 202', ' 2')
      .replace('January', 'Jan')
      .replace('February', 'Feb')
      .replace('March', 'Mar')
      .replace('April', 'Apr')
      .replace('May', 'May')
      .replace('June', 'Jun')
      .replace('July', 'Jul')
      .replace('August', 'Aug')
      .replace('September', 'Sep')
      .replace('October', 'Oct')
      .replace('November', 'Nov')
      .replace('December', 'Dec')
  }
  const id = `widthId_${title.replace(/[^a-zA-Z0-9]/g, '')}`
  let yAxisTicks = Math.round(maxValue / 10)

  if (maxValue <= 20) {
    yAxisTicks = 4
  } else if (maxValue <= 10) {
    yAxisTicks = maxValue
    if (maxValue <= 8) yAxisTicks = 4
    if (maxValue <= 4) {
      maxValue = 4
      yAxisTicks = 4
    }
  }

  const settings = {
    height: isPPTModalActive ? 200 : 250,
    width: isPPTModalActive ? 220 : cardWidth || '100%',
    barWidth: progressRangeObject?.barWidth || 22,
    margin: { top: 20, right: 0, bottom: 30, left: 40 },
    scaleY: true,
    scaleLineColor: 'transparent',
    scaleTextColor: '#8B8B89',
    customToolTip: 'toolTip1',
    toolTip: true,
    maxValue: maxValue,
    yAxisTicks: yAxisTicks,
    color: [
      LEGEND_COLOR_MAP_NEW.Positive,
      LEGEND_COLOR_MAP_NEW.Neutral,
      LEGEND_COLOR_MAP_NEW.Mixed,
      LEGEND_COLOR_MAP_NEW.Negative,
    ],
  }
  if (['SearchDriversProgression3Level'].includes(insightsElementType)) {
    settings.color = [LEGEND_COLOR_MAP_NEW.SearchKeywords]
  } else if (['DriversProgressionWithoutSentiments3Level', 'DriversProgressionWithoutSentiments'].includes(insightsElementType)) {
    settings.color = [LEGEND_COLOR_MAP_NEW.WithoutSentiments]
  }

  const year = new Date().getFullYear()
  const data2 = keyOrdering
    .map((d) => {
      const obj = {
        label: trimName(d),
        fullLabel: d,
        otherDetails: selectedItemsL[d] || {},
        values: {
          v1: selectedItemsL[d]?.PositivePercent || 0,
          v2: selectedItemsL[d]?.NeutralPercent || 0,
          v3: selectedItemsL[d]?.MixedPercent || 0,
          v4: selectedItemsL[d]?.NegativePercent || 0,
        },
      }
      if (
        ['SearchDriversProgression3Level', 'DriversProgressionWithoutSentiments3Level', 'DriversProgressionWithoutSentiments'].includes(
          insightsElementType
        )
      ) {
        obj.values = { v1: selectedItemsL[d]?.Percent || 0 }
      }
      return obj
    })
    .slice(0, progressRangeObject.barsInGraph)
    .filter((f) =>
      progressRangeObject.barsInGraph === 15 ? f?.otherDetails?.CreatedDate?.match(year)?.length : f
    )
    .reverse()

  const showGraph = data2.some(({ values }) => Object.values(values).some((value) => value > 0))

  const isSelected = () => {
    if (
      type === 'level_1' &&
      itemLevels?.expandedLevel1Key === title &&
      itemLevels?.expandedLevel1Index === index
    ) {
      return 'selected'
    } else if (
      type === 'level_2' &&
      itemLevels?.expandedLevel2Key === title &&
      itemLevels?.expandedLevel2Index === index
    ) {
      return 'selected'
    }
    return ''
  }

  const expandClicked = () => {
    const obj = { showId: insightsElementId }
    if (type === 'level_1') {
      obj.level_1 = title
    } else if (type === 'level_2') {
      obj.level_1 = itemLevels.expandedLevel1Key
      obj.level_2 = title
    } else if (type === 'level_3') {
      obj.level_1 = itemLevels.expandedLevel1Key
      obj.level_2 = itemLevels.expandedLevel2Key
      obj.level_3 = title
    }
    setDriverProgressionPopupObject({ ...driverProgressionPopupObject, ...obj })
  }

  useEffect(() => {
    let hadNxtLevel = false
    if (type === 'level_1' && Object.keys(itemLevels?.dataLevel2 || {})?.length > 0) {
      hadNxtLevel = true
    }
    if (type === 'level_2' && hadNextLevel && showLevel2Button) {
      hadNxtLevel = true
    }
    setShowArrowButton(hadNxtLevel)
  }, [type, itemLevels, hadNextLevel, showLevel2Button])

  return (
    <SegmentRow className={`_segmentRows ${isSelected()}`} style={{ width: settings.width }}>
      <SegmentRowHeading>
        <span title={title}>{title}</span>
        {type === 'level_1' && showArrowButton && (
          <CustomTooltip title={isSelected() === 'selected' ? 'Collapse' : 'Expand'} valign='bottom'><Button size='small' className='arrowDown' onClick={(e) => expandLevelFunc(title)}>
            <IconArrowDown />
          </Button></CustomTooltip>
        )}
        {type === 'level_2' && showArrowButton && (
          <CustomTooltip title={isSelected() === 'selected' ? 'Collapse' : 'Expand'} valign='bottom'><Button size='small' className='arrowDown' onClick={(e) => expandLevelFunc(itemLevels.expandedLevel1Key, index, title)}>
            <IconArrowDown />
          </Button></CustomTooltip>
        )}
        <CustomTooltip className='expand' title='Full Graph' valign='bottom'><Button size='small' className={`expand expandGraph ${showArrowButton ? 'showArrow' : 'hideArrow'}`} onClick={() => expandClicked()}>
          <IconExpand variant='secondary' />
        </Button></CustomTooltip>
      </SegmentRowHeading>
      <SegmentRowDetails id={id}>
        {data2.length > 0 && (
          <D3VerticalStacked
            settings={{ ...settings, width: settings.width - 2 }}
            data={data2}
            insightsElementType={insightsElementType}
            insightsElementId={insightsElementId}
            showNoDataFound={!showGraph}
          />
        )}
      </SegmentRowDetails>
    </SegmentRow>
  )
}

const SegmentLevel2DetailSection = ({
  getCardWidth,
  itemLevel1,
  keyL2,
  segmentDataL1Filtered,
  filterType,
  keyOrdering,
  segmentDataLevel3,
  expandLevel2Func,
  expandedLevel2Data,
  progressRangeObject,
  progressionRangeObject,
  progressionRangeArray,
  onCloseL1,
  insightsElementType,
  insightsElementId,
}) => {
  const [progressionRangeObjectL2, setProgressionRangeObjectL2] = useState({
    ...progressionRangeObject,
  })
  const [segmentDataLevel2MaxValue, setSegmentDataLevel2MaxValue] = useState(100)
  const [card, setCard] = useState({})
  const keys = Object.keys(itemLevel1?.dataLevel2)

  const setLevel2MaxValueFunc = () => {
    const maxPercentArr = []
    for (let i = 0; i < keys.length; i++) {
      const keyData = itemLevel1.dataLevel2[keys[i]]
      const childKeys = keyOrdering // Object.keys(keyData)
      const len =
        childKeys.length > progressionRangeObjectL2.barsInGraph
          ? progressionRangeObjectL2.barsInGraph
          : childKeys.length
      for (let j = 0; j < len; j++) {
        maxPercentArr.push(keyData[childKeys[j]]?.Percent || 0)
      }
    }
    const mx = Math.max(...maxPercentArr)
    let maxPercentValue = Math.ceil(mx / 10) * 10
    if (maxPercentValue <= 10) {
      maxPercentValue = mx <= 7 ? 8 : 10
      if (mx <= 4) maxPercentValue = 4
    }

    setSegmentDataLevel2MaxValue(maxPercentValue)
  }

  useEffect(() => {
    setLevel2MaxValueFunc()
  }, [progressionRangeObjectL2])

  useEffect(() => {
    const crd = getCardWidth('.segmentRowsLevel2', progressionRangeObjectL2, 12)
    setCard(crd)
  }, [progressionRangeObjectL2])

  return (
    <>
      {itemLevel1?.expandedLevel1 && (
        <SegmentDetailsLevel2 className='segmentRowsLevel2'>
          <SegmentAccordionLevelHeading className='heading'>
            {itemLevel1.expandedLevel1Key} - Attributes
            <Box>
              {progressionRangeObjectL2 && (
                <ProgressionRange
                  data={progressionRangeArray}
                  progressionRangeObject={progressionRangeObjectL2}
                  setProgressionRangeObject={setProgressionRangeObjectL2}
                />
              )}
              <MuiButton
                color='light'
                variant='outlined'
                startIcon={<IconClose />}
                onClick={() => onCloseL1()}
                style={{ marginLeft: '12px' }}
              />
            </Box>
          </SegmentAccordionLevelHeading>

          {card &&
            keys.map((key, j) => {
              const showLevel2Button = expandLevel2Func(keyL2, j, key, true)
              const selected = itemLevel1.expandedLevel2 && itemLevel1?.expandedLevel2Index === j
              const selectedItemsL2 = {}
              const arr2 = segmentDataL1Filtered[filterType]
              for (let s = 0; s < arr2.length; s++) {
                if (itemLevel1.dataLevel2[key][arr2[s]]) {
                  selectedItemsL2[arr2[s]] = itemLevel1.dataLevel2[key][arr2[s]]
                }
              }
              let hadNextLevel = false
              const itemL2 = Object.keys(selectedItemsL2)
              for (let i = 0; i < itemL2.length; i++) {
                if (selectedItemsL2[itemL2[i]]?.DriverSubAttributes) {
                  hadNextLevel = true
                  break
                }
              }
              if (Object.keys(selectedItemsL2).length === 0) {
                return false
              }

              const showDetailSectionL2 = () => {
                if (expandedLevel2Data?.index >= 0) {
                  const modulusE = (j % card.cols) + 1 === card.cols
                  const driverLen = Object.keys(itemLevel1?.dataLevel2).length - 1
                  const last = driverLen === j
                  const lastIndexDif = driverLen - (driverLen % card.cols)

                  if (
                    modulusE &&
                    expandedLevel2Data?.index > j - card.cols &&
                    expandedLevel2Data?.index <= j
                  ) {
                    return true
                  } else if (last && expandedLevel2Data?.index >= lastIndexDif) {
                    return true
                  }
                }
                return false
              }

              return (
                <>
                  <CardSection
                    key={'level2 ' + key}
                    type='level_2'
                    title={key}
                    expandLevelFunc={expandLevel2Func}
                    keyOrdering={keyOrdering}
                    progressRangeObject={progressionRangeObjectL2}
                    progressionRangeArray={progressionRangeArray}
                    itemLevels={itemLevel1}
                    index={j}
                    selectedItemsL={selectedItemsL2}
                    cardWidth={card.width}
                    hadNextLevel={hadNextLevel}
                    showLevel2Button={showLevel2Button}
                    selected={selected}
                    segmentDataLevel3={segmentDataLevel3}
                    maxValue={segmentDataLevel2MaxValue}
                    insightsElementType={insightsElementType}
                    insightsElementId={insightsElementId}
                  />
                  {showDetailSectionL2() &&
                    segmentDataLevel3 &&
                    itemLevel1.dataLevel2[itemLevel1.expandedLevel2Key] && (
                      <SegmentLevel3DetailSection
                        key={'level3 detail section '}
                        getCardWidth={getCardWidth}
                        progressionRangeArray={progressionRangeArray}
                        itemLevel1={itemLevel1}
                        // itemLevel1={expandedLevel2Data.itemLevel1}
                        keyOrdering={keyOrdering}
                        segmentDataL1Filtered={segmentDataL1Filtered}
                        subTitle={Object.keys(segmentDataLevel3)}
                        itemData={segmentDataLevel3}
                        onCloseL3={() =>
                          expandLevel2Func(
                            itemLevel1.expandedLevel1Key,
                            itemLevel1.expandedLevel2Index,
                            itemLevel1.expandedLevel2Key
                          )
                        }
                        progressRangeObject={progressRangeObject}
                        insightsElementType={insightsElementType}
                        insightsElementId={insightsElementId}
                      />
                    )}
                </>
              )
            })}
        </SegmentDetailsLevel2>
      )}
    </>
  )
}

const SegmentLevel3DetailSection = ({
  getCardWidth,
  progressionRangeArray,
  keyOrdering,
  itemLevel1,
  segmentDataL1Filtered,
  subTitle,
  itemData,
  onCloseL3,
  progressRangeObject,
  insightsElementType,
  insightsElementId,
}) => {
  const [progressionRangeObjectL3, setProgressionRangeObjectL3] = useState({})
  const [selectedItemsL3Array, setSelectedItemsL3Array] = useState()
  const [selectedItemsL3ArrayKeys, setSelectedItemsL3ArrayKeys] = useState()
  const [titleObject, setTitleObject] = useState()
  const [segmentDataLevel3MaxValue, setSegmentDataLevel3MaxValue] = useState(100)
  const [card, setCard] = useState({})

  const setLevel3MaxValueFunc = () => {
    const maxPercentArr = []
    const keys = selectedItemsL3ArrayKeys

    for (let i = 0; i < keys.length; i++) {
      const keyData = titleObject[keys[i]]
      const childKeys = keyOrdering // Object.keys(keyData)
      const len =
        childKeys.length > progressionRangeObjectL3.barsInGraph
          ? progressionRangeObjectL3.barsInGraph
          : childKeys.length
      for (let j = 0; j < len; j++) {
        maxPercentArr.push(keyData[childKeys[j]] || 0)
      }
    }

    const mx = Math.max(...maxPercentArr)
    let maxPercentValue = Math.ceil(mx / 10) * 10
    if (maxPercentValue <= 10) {
      maxPercentValue = mx <= 7 ? 8 : 10
      if (mx <= 4) maxPercentValue = 4
    }

    setSegmentDataLevel3MaxValue(maxPercentValue)
  }

  useEffect(() => {
    if (selectedItemsL3Array?.length > 0 && selectedItemsL3ArrayKeys?.length > 0) {
      setLevel3MaxValueFunc()
    }
  }, [progressionRangeObjectL3, selectedItemsL3Array, selectedItemsL3ArrayKeys, titleObject])

  useEffect(() => {
    const selectedItemsL3Arr = []

    const selectedItemsL3 = []
    const titleObj = {}
    for (let r = 0; r < subTitle.length; r++) {
      const data = subTitle[r]
      titleObj[data] = {}
      const arr3 = segmentDataL1Filtered?.segments || segmentDataL1Filtered?.periods
      for (let s = 0; s < arr3.length; s++) {
        if (itemData[data][arr3[s]]) {
          titleObj[data][arr3[s]] = itemData[data][arr3[s]].Percent
          selectedItemsL3.push({
            data: { [arr3[s]]: itemData[data][arr3[s]] },
            title: data,
          })
        }
      }

      if (Object.keys(selectedItemsL3).length > 0) {
        selectedItemsL3Arr.push(selectedItemsL3)
      }
    }
    setTitleObject(titleObj)
    setSelectedItemsL3Array(selectedItemsL3Arr)
    if (Object.keys(selectedItemsL3Arr).length === 0) return false
    setSelectedItemsL3ArrayKeys(getDistinctValues(selectedItemsL3Arr.flat(1).map((d) => d.title)))
  }, [itemData])

  useEffect(() => {
    const crd = getCardWidth('.segmentRowsLevel3', progressionRangeObjectL3, 12)
    setCard(crd)
  }, [progressionRangeObjectL3])

  return (
    <SegmentDetailsLevel3 className='segmentRowsLevel3'>
      <SegmentAccordionLevelHeading className='heading'>
        {itemLevel1.expandedLevel2Key} - Sub-attributes
        <Box>
          <ProgressionRange
            data={progressionRangeArray}
            progressionRangeObject={progressionRangeObjectL3}
            setProgressionRangeObject={setProgressionRangeObjectL3}
          />
          {/* <MuiButtons size='small' onClick={(e) => onCloseL3()}><ClosePopup type={'square'} /></MuiButtons> */}
          <MuiButton
            color='light'
            variant='outlined'
            startIcon={<IconClose />}
            onClick={(e) => onCloseL3()}
            style={{ marginLeft: '12px' }}
          />
        </Box>
      </SegmentAccordionLevelHeading>
      {itemData &&
        selectedItemsL3ArrayKeys?.length &&
        selectedItemsL3ArrayKeys.map((key, k) => {
          const finalData1 = selectedItemsL3Array[0]
            .filter((f) => f.title === key)
            .map((d) => d.data)
          const finalData2 = {}
          for (let i = 0; i < finalData1.length; i++) {
            const k = Object.keys(finalData1[i])[0]
            finalData2[k] = finalData1[i][k]
          }

          return (
            <CardSection
              key={'level3 ' + key}
              type='level_3'
              title={key}
              keyOrdering={keyOrdering}
              progressRangeObject={progressionRangeObjectL3}
              itemLevels={itemLevel1}
              index={k}
              selectedItemsL={finalData2}
              cardWidth={card.width}
              maxValue={segmentDataLevel3MaxValue}
              insightsElementType={insightsElementType}
              insightsElementId={insightsElementId}
            />
          )
        })}
    </SegmentDetailsLevel3>
  )
}
